import React, { Component } from "react";
import { Grid, Icon, List, ListItemIcon, ListItemText, ListItem, Button, Divider } from "@mui/material";

import env from "../../../env";
import { Link } from "../../../routing";

import Animate from "../../components/Animations";
// import ContactFormDialog from "../../components/ContactFormDialog";
import FacebookBot from "../../components/FacebookBot";
import TelegramBot from "../../components/TelegramBot";
import Presentation from "../../components/Presentation";
import Reactor from "../../components/Reactor";
import Text from "../../components/Text";

import "./Home.styl";

export default class Home extends Component {
    displayName = Home.name

    state = {
        showContactDialog: false,
    };

    mergeState = (newState) => this.setState(oldState => ({ ...oldState, ...newState }));
    openContactDialog = () => this.mergeState({ showContactDialog: true });
    closeContactDialog = () => this.mergeState({ showContactDialog: false });

    render() {
        return (
            <div tabIndex={0} aria-label="Conteúdo da página inicial" className="Home">
                <section id="presentation" aria-label="Seção de apresentação da página inicial" className="frame padded flex ai-c jc-c" style={{ paddingTop: 50, backgroundImage: `url(${env.images.earthLights})` }}>
                    <div className="holder">
                        <div tabIndex={0} className="flex jc-c">
                            <img className="geolux-logo" src={env.images.geoluxLogo} alt="Logo da empresa Geolux para gestão de iluminação pública" />
                        </div>
                        <Text as="h1" className="header align-center">A solução ideal para a gestão da iluminação pública!</Text>
                        <div id="selections" className="flex jc-c" style={{marginTop: 45}}>
                            <Link to="cityHall" style={{marginRight: 20}}>
                                <Button className="button white outline"><Icon className="icon">location_city</Icon>prefeituras</Button>
                            </Link>
                            <Link to="contractor">
                                <Button className="button white outline"><Icon className="icon">lightbulb</Icon>empreiteiras</Button>
                            </Link>
                        </div>
                    </div>
                </section>
                <section id="carousel" className="frame padded equally app background gradient white" aria-label="Seção com um carrossel de imagens e textos apresentando o produto">
                    <div className="container">
                        <Reactor>
                        {
                            ({visible}) => (
                                <Presentation paused={!visible}>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Animate in={active} fadeInRight>
                                                <Link to="cityHall">
                                                    <div style={{backgroundImage: `url(${env.images.home.carousel.cityHall})`}} className="image flex ai-fe">
                                                        <div className="darken">
                                                            <Text as="h2" className="align-left">Benefícios para prefeituras</Text>
                                                            <Text className="align-left">Descubra como o Geolux pode ajudar sua prefeitura.</Text>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </Animate>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Animate in={active} fadeInRight>
                                                <Link to="contractor">
                                                    <div style={{backgroundImage: `url(${env.images.home.carousel.contractor})`}} className="image flex ai-fe">
                                                        <div className="darken">
                                                            <Text as="h2" className="align-left">Benefícios para empreiteiras</Text>
                                                            <Text className="align-left">Uma gestão eficiente para aumentar seus ganhos! Descubra aqui!</Text>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </Animate>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Animate in={active} fadeInRight>
                                                <div style={{backgroundImage: `url(${env.images.home.carousel.citizen})`}} className="image flex ai-fe">
                                                    <div className="darken">
                                                        <Text as="h2" className="align-left">Benefícios para os munícipes</Text>
                                                        <Text className="align-left">Comunicação aberta entre prefeitura e cidadão!</Text>
                                                    </div>
                                                </div>
                                            </Animate>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Animate in={active} fadeInRight>
                                                <Link to="news">
                                                    <div style={{backgroundImage: `url(${env.images.home.carousel.news})`}} className="image flex ai-fe">
                                                        <div className="darken">
                                                            <Text as="h2" className="align-left">Notícias relacionadas</Text>
                                                            <Text className="align-left">Várias cidades já utilizam o Geolux. Veja as notícias!</Text>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </Animate>
                                        )
                                    }
                                    </Presentation.Slide>
                                </Presentation>
                            )
                        }
                        </Reactor>
                    </div>
                </section>
                <section id="features" aria-label="Características do produto" className="frame padded parallax app background darker blue">
                    <Reactor triggerOnce>
                    {
                        ({ visible }) => (
                            <Animate in={visible} fadeInUp>
                                <Text as="h1" className="align-center">O que o Geolux oferece</Text>
                                <Grid container>
                                    <Grid item xs={12} md={6} lg={3} className="align-center column">
                                        <Animate in={visible} fadeInUp delay={200}>
                                            <Icon className="top-icon">lightbulb_outline</Icon>
                                            <Text as="h2" className="uppercase">Parque de Iluminação</Text>
                                            <List>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Mapa georreferenciado com seus pontos luminosos</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Simulador de intervenção</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Detalhamento de equipamentos</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Relatórios e gráficos de consumo de energia (medido e calculado)</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Relatórios de custos de manutenção</Text></ListItemText>
                                                </ListItem>
                                            </List>
                                        </Animate>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3} className="align-center column">
                                        <Animate in={visible} fadeInUp delay={600}>
                                            <Icon className="top-icon">location_on</Icon>
                                            <Text as="h2" className="uppercase">Operações em Campo</Text>
                                            <List>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Fácil gerenciamento de equipes de manutenção</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Cadastramento e execução de serviços in loco, online e offline</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Relatórios de eficiência de atendimento e produtividade das equipes de campo, além de diversos outros relatórios</Text></ListItemText>
                                                </ListItem>
                                            </List>
                                        </Animate>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3} className="align-center column">
                                        <Animate in={visible} fadeInUp delay={1000}>
                                            <Icon className="top-icon">business</Icon>
                                            <Text as="h2" className="uppercase">Gestão de Materiais</Text>
                                            <List>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Controle de estoque sincronizado com a execução de Ordens de Serviço</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Índice de materiais com defeito em garantia</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Gastos com contratos</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Relatórios e gráficos de vida útil dos materiais, uso do estoque e muitos outros</Text></ListItemText>
                                                </ListItem>
                                            </List>
                                        </Animate>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3} className="align-center column">
                                        <Animate in={visible} fadeInUp delay={1400}>
                                            <Icon className="top-icon">language</Icon>
                                            <Text as="h2" className="uppercase">Tecnologia</Text>
                                            <List>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Dados criptografados</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Backups regulares</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Atendentes virtuais para Facebook e Telegram</Text></ListItemText>
                                                </ListItem>
                                                <ListItem className="features ListItem">
                                                    <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                                    <ListItemText><Text className="text">Exportação de relatórios para planilhas Excel</Text></ListItemText>
                                                </ListItem>
                                            </List>
                                        </Animate>
                                    </Grid>
                                </Grid>
                            </Animate>
                        )
                    }
                    </Reactor>
                </section>
                <section id="contact" aria-label="Seção de informações de contato" className="frame padded">
                    <Animate fadeInUp>
                        <Text as="h1" className="align-center">Se interessou? Entre em contato!</Text>
                        <Grid container spacing={32}>
                            {/* <Grid item xs={12} md={6} className="align-center column">
                                <Animate fadeInUp delay={200}>
                                    <Text as="h2">Nos deixe uma mensagem</Text>
                                    <Icon className="icon">insert_comment</Icon>
                                    
                                    <Text as="h3" className="align-justify">Formulário de contato</Text>
                                    <Text className="align-left">Você pode entrar em contato conosco pelo nosso formulário de contato, que pode ser acessado clicando no botão abaixo.</Text>
                                    <Button onClick={this.openContactDialog}>Entre em contato</Button>
                                    <ContactFormDialog open={this.state.showContactDialog} onClose={this.closeContactDialog} />
                                </Animate>
                            </Grid> */}
                            <Grid item xs={12} md={12} className="align-center">
                                <Animate fadeInUp delay={600}>
                                    <Text as="h2">Envie um email</Text>
                                    <Icon className="icon">email</Icon>
                                    <Text className="align-center">Sinta-se à vontade para nos contatar pelo email <a href="mailto: contato@geolux.com.br">contato@geolux.com.br</a></Text>
                                </Animate>
                            </Grid>
                        </Grid>
                    </Animate>
                </section>
                <Divider />
                <section id="virtual-attendants" aria-label="Sobre os Atendentes Virtuais" className="frame padded virtual-attendants app background darker blue">
                    <Animate fadeInUp>
                        <Text as="h1" className="align-center">Como entrar em contato com nossos atendentes virtuais</Text>
                        <Grid container spacing={0}>
                            <Grid item xs={12} md={6} className="facebook">
                            </Grid>
                            <Grid item xs={12} md={6} className="telegram">
                            </Grid>
                        </Grid>
                        <div className="flex wrap jc-c">
                            <div className="facebook">
                                <FacebookBot />
                            </div>
                            <div className="telegram">
                                <TelegramBot />
                            </div>
                        </div>
                    </Animate>
                </section>
            </div>
        );
    }
}
